import { useQuery } from 'react-query';
import type { InvoiceDataViewDto } from '@subscriptions/application/dtos';
import { getInvoiceDataUseCases } from '@subscriptions/composition';

/**
 * Reads one fiscal record on its own, deleted ones included.
 *
 * The listing hides deleted records, so a retry link naming one resolves to nothing there. This
 * is the only reader that asks for them, and it never backs the listing.
 *
 * @param invoiceDataUuid - Record to read, or null when there is no target
 * @param options - Optional query configuration
 */
export const useInvoiceDataByUuid = (invoiceDataUuid: string | null, options?: { enabled?: boolean }) => {
  const { getInvoiceData } = getInvoiceDataUseCases();

  return useQuery<InvoiceDataViewDto, Error>(
    ['subscriptions', 'invoice-data', 'detail', invoiceDataUuid],
    () => getInvoiceData.execute(invoiceDataUuid as string, true),
    {
      enabled: Boolean(invoiceDataUuid) && (options?.enabled ?? true),
      refetchOnWindowFocus: false,
      retry: 0,
    },
  );
};
